import SDIcon from './SDIcon'

const IconCarbonHome = (props) => (
  <SDIcon title='Home' {...props}>
    <path
    d='M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonHome
